export type TextSegment = { type: 'text' | 'link'; value: string };

// http(s) only: a user-controlled string must never become a
// javascript:/file:/data: link.
const URL_PATTERN = /https?:\/\/[^\s<>]+/gi;
const TRAILING_PUNCTUATION = /[.,;:!?'"\]}]+$/;

// A closing paren belongs to the URL only when it balances an opening one
// inside it, as in https://en.wikipedia.org/wiki/Foo_(bar).
function trimUrl(raw: string): string {
  let url = raw;

  for (;;) {
    const stripped = url.replace(TRAILING_PUNCTUATION, '');
    const unbalancedParen = stripped.endsWith(')') && stripped.split(')').length > stripped.split('(').length;

    if (unbalancedParen) {
      url = stripped.slice(0, -1);
    } else if (stripped === url) {
      return url;
    } else {
      url = stripped;
    }
  }
}

// Splits body text into plain and link segments. Joining every segment's
// value reproduces the input exactly.
export function splitLinks(text: string): TextSegment[] {
  const segments: TextSegment[] = [];
  let cursor = 0;

  for (const match of text.matchAll(URL_PATTERN)) {
    const start = match.index;
    const url = trimUrl(match[0]);

    if (!/^https?:\/\/[\w[]/i.test(url)) continue;

    if (start > cursor) segments.push({ type: 'text', value: text.slice(cursor, start) });
    segments.push({ type: 'link', value: url });
    cursor = start + url.length;
  }

  if (cursor < text.length) segments.push({ type: 'text', value: text.slice(cursor) });

  return segments;
}
